<template>
    <div id="app">
        <!-- <div id="nav"> -->
            <!-- <router-link 
              v-if="authenticated" 
              to="/login" 
              v-on:click.native="logout()" 
              replace>
            </router-link> -->
        <!-- </div> -->
        <!-- <router-view @authenticated="setAuthenticated" /> -->
        <WebAudio/>
    </div>
</template>

<script>
import WebAudio from "./components/WebAudio.vue"

export default {
  name: 'app',
  components: {
    WebAudio
  }
}

</script>
  


<style lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;700&display=swap');
  /** SOUND VOYAGE LOGO -> SCSS SET UP                **/
      .stageSound {
      transform-style: preserve-3d;
      z-index: -99;
      }
      .stageVoyage {
      transform-style: preserve-3d;
      z-index: -99;
      }

      .layerSound {
      transform-style: preserve-3d;
      transform: rotateY(10deg) rotateX(15deg) translateZ(0);
      }
      .layerVoyage {
      transform-style: preserve-3d;
      transform: rotateY(10deg) rotateX(15deg) translateZ(0);
      } 
  /** SOUND VOYAGE LOGO -> DEVICE SIZINGS             **/
    @media (max-width: 320px) {
        .stageSound {
            position: relative; 
            top: -120px; right: 0; bottom: 0; left: -320px;
        }

        .layerSound:after {
            font: 2em Avenir, 'Nunito Sans';
            -webkit-text-stroke: 1.5px black;
        }
    }
    @media (min-width: 321px) and (max-width: 766px) {
        .stageSound {
            position: relative; 
            top: -60px; right: 0; bottom: 0; left: -175px;
        }

        .layerSound:after {
            font: 3em Avenir, 'Nunito Sans';
            -webkit-text-stroke: 1.25px black;
        }
    }
    @media (min-width: 767px) and (max-width: 832px) {
        .stageSound {
            position: relative; 
            top: -100px; right: 0; bottom: 0; left: -280px;
        }

        .layerSound:after {
            font: 5em Avenir, 'Nunito Sans';
            -webkit-text-stroke: 1.5px black;
        }
    } 
    @media (min-width: 833px) and (max-width: 1198px) {
        .stageSound {
            position: relative; 
            top: -120px; right: 0; bottom: 0; left: -320px;
        }

        .layerSound:after {
            font: 6em Avenir, 'Nunito Sans';
            -webkit-text-stroke: 1.5px black;
        }
    }
    @media (min-width: 1199px) {
        .stageSound {
            position: relative; 
            top: -120px; right: 0; bottom: 0; left: -320px;
        }

        .layerSound:after {
            font: 6em Avenir, 'Nunito Sans';
            -webkit-text-stroke: 1.5px black;
        }
    } 
  /** SOUND VOYAGE LOGO -> COMPUTE CSS -- ALL SIZINGS **/
    .layerSound:after {
    /*content: 'Sound Voyage';*/
    content:   '     moody  ';
    white-space: pre;
    letter-spacing: 3px;
    font-weight: 700;
    position: absolute;
    color: rgba(255,255,255,0.95);
    }

    $i: 1;
    $NUM_LAYERS: 12;
    @for $i from 1 through $NUM_LAYERS {
      .layerSound:nth-child(#{$i}):after{
          transform: translateZ(($i - 1) * -1px);
      }
    }
    .layerSound:nth-child(n+#{round($NUM_LAYERS/2)}):after {
        -webkit-text-stroke: 4px black;
    }
    /*.layerSound:nth-child(n+#{round($NUM_LAYERS/1)}):after {
        -webkit-text-stroke: 0px var(--main-sceneAccent);
    }*/
</style>
